export default __webpack_public_path__ + "03eeda71b6fbc387169d811febc2aa5a.webp";